import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconLoggedIn: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M36.707 35.026c1.384 2.2 2.212 4.786 2.287 7.56-.64-.212-1.419-.408-2.315-.584l-.694-.13c-.596-.104-1.235-.201-1.913-.29l-.832-.1c-.283-.033-.572-.064-.867-.093l-.9-.084-.93-.075c-.158-.011-.316-.023-.476-.033l-.973-.06c-.164-.01-.33-.018-.496-.026l-1.011-.044c-.341-.013-.686-.024-1.034-.033L25.5 41.01c-.355-.005-.713-.009-1.073-.01L24 41c-.36 0-.718.002-1.073.006l-1.056.017-1.036.029-1.014.04-.991.05-.965.06-.938.07c-.153.012-.306.024-.457.038l-.893.083-.434.046-.842.097c-.275.034-.544.069-.807.105l-.77.114c-1.5.235-2.764.516-3.718.83C9.226 34.492 15.855 28 24 28c2.15 0 4.195.453 6.045 1.268" />
            <circle cx="24" cy="14" r="9" />
            <path d="M23.999 33.249L29 37 39 26" />
          </g>
        </svg>
      </div>
    </div>
  )
}
export default IconLoggedIn
